export default __webpack_public_path__ + "static/app-store-download-9f203d83e2653968a9a208bd726b358d.png";